<div class="modal--container">
  <div class="modal-body">
    <div class="close-button--container">
      <div class="modal-title">Recovery Codes</div>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="close"
        ariaLabel="Close"
        (buttonClicked)="close()"
      ></app-mat-icon-button>
    </div>
    @if (!showCodes()) {
      <p class="body1">
        Enter your password to generate new recovery codes. This will invalidate
        any previously generated codes.
      </p>
      <form [formGroup]="parentForm()">
        <app-underlined-form-field
          iconName="lock"
          [parentForm]="parentForm()"
          [field]="passwordField()"
        ></app-underlined-form-field>
        <app-underlined-form-field
          [parentForm]="parentForm()"
          [field]="codeField()"
        ></app-underlined-form-field>
      </form>
      @if (error()?.message) {
        <p class="error">{{ error().message }}</p>
      }
      <div class="button--container double">
        <app-button
          buttonStyle="secondary"
          [label]="secondaryButtonText()"
          [buttonId]="secondaryButtonId()"
          (buttonClicked)="buttonEventHandler(secondaryButtonId())"
          [isDisabled]="isProcessing()"
        ></app-button>
        <app-button
          [label]="primaryButtonText()"
          [buttonId]="primaryButtonId()"
          (buttonClicked)="buttonEventHandler(primaryButtonId())"
          [isDisabled]="isProcessing() || parentForm()?.invalid"
          [isProcessing]="isProcessing()"
        ></app-button>
      </div>
    } @else {
      <div id="recovery-codes">
        <div class="body1">
          If you lose access to your authentication app, you can sign in using
          your recovery codes. Each code can only be used once. Save these codes
          somewhere safe - you won't be able to view them again.
        </div>
        <div class="codes">
          @for (code of recoveryCodes() ?? []; track code) {
            <div class="code">{{ code }}</div>
          }
        </div>
        <div class="actions">
          <div class="info">
            <mat-icon>info</mat-icon>
            <div class="body2">Keep your recovery codes in a secure place</div>
          </div>
          <app-mat-outlined-button
            label="Copy"
            ariaLabel="Copy Recovery Codes"
            buttonId="copy-recovery-codes-btn"
            iconName="arrow_forward"
            iconPosition="right"
            (buttonClicked)="copyRecoveryCodes()"
          >
          </app-mat-outlined-button>
        </div>
        @if (clipboardError()) {
          <p class="error body2" role="alert">{{ clipboardError() }}</p>
        }
        <app-checkbox
          [checkbox]="savedRecoveryCodes"
          [parentForm]="recoveryCodeForm"
        ></app-checkbox>
        <app-button
          buttonStyle="standard"
          label="Done"
          buttonId="done-btn"
          [isDisabled]="recoveryCodeForm.invalid"
          (buttonClicked)="buttonEventHandler('done-btn')"
        >
        </app-button>
      </div>
    }
  </div>
</div>
<div class="modal--backdrop"></div>
